import AdicionarPerfilPermissao from '@/templates/Cadastro/Permissoes/modals/AdicionarPerfilPermissao'
import AssociarPerfilPermissao from '@/templates/Cadastro/Permissoes/modals/AssociarPerfilPermissao'
import EditarPerfilPermissao from '@/templates/Cadastro/Permissoes/modals/EditarPerfilPermissao'
import ExcluirPerfilPermissao from '@/templates/Cadastro/Permissoes/modals/ExcluirPerfilPermissao'
import ExcecoesRubricas from '@/templates/Cadastro/Rubricas/ExcecoesRubricas'
import React from 'react'
import { RouteObject } from 'react-router-dom'
import AdicionarCentroCusto from 'templates/Cadastro/CentroCusto/atoms/modals/AdicionarPage'
import EditarCentroCusto from 'templates/Cadastro/CentroCusto/atoms/modals/Editar'
import ExcluirCentroCusto from 'templates/Cadastro/CentroCusto/atoms/modals/Excluir'
import ImportarCentroCusto from 'templates/Cadastro/CentroCusto/atoms/modals/Importar'
import FuncionariosCentroCusto from 'templates/Cadastro/CentroCusto/atoms/modals/ListaFuncionarios'
import AdicionarEmpresaPage from 'templates/Cadastro/Empresas/modals/Adicionar'
import DetalhesEmpresaPage from 'templates/Cadastro/Empresas/modals/Detalhes'
import EdicaoEmpresaPage from 'templates/Cadastro/Empresas/modals/Editar'
import AdicionarEscalaModal from 'templates/Cadastro/Escalas/modals/Adicionar'
import AssociarFuncionarios from 'templates/Cadastro/Escalas/modals/Associar'
import EditarEscalaModal from 'templates/Cadastro/Escalas/modals/Editar'
import ExcluirEscala from 'templates/Cadastro/Escalas/modals/Excluir'
import ExcluirAssociacao from 'templates/Cadastro/Escalas/modals/ExcluirAssociacao'
import AdicionarFeriadoModal from 'templates/Cadastro/FeriadosCliente/atoms/modals/Adicionar'
import ExcluirFeriadoModal from 'templates/Cadastro/FeriadosCliente/atoms/modals/Excluir'
import AdicionarFuncionarioPage from 'templates/Cadastro/Funcionarios/organismos/modals/Adicionar'
import AlterarSenhaFuncionario from 'templates/Cadastro/Funcionarios/organismos/modals/AlterarSenhaFuncionario'
import DetalhesFuncionarioPage from 'templates/Cadastro/Funcionarios/organismos/modals/Detalhes'
import EditarFuncionarioPage from 'templates/Cadastro/Funcionarios/organismos/modals/Editar'
import ExportarFuncionarioPage from 'templates/Cadastro/Funcionarios/organismos/modals/Exportar'
import CadastroFacialPage from 'templates/Cadastro/Funcionarios/organismos/modals/Facial'
import ImportarFuncionarioPage from 'templates/Cadastro/Funcionarios/organismos/modals/Importar'
import AdicionarLocal from 'templates/Cadastro/Locais/modals/AdicionarPage'
import AssociarLocal from 'templates/Cadastro/Locais/modals/AssociarFuncionarios'
import EditarLocal from 'templates/Cadastro/Locais/modals/Editar'
import ExcluirLocal from 'templates/Cadastro/Locais/modals/Excluir'
import AdicionarOcorrencias from 'templates/Cadastro/Ocorrencias/modals/Adicionar'
import EditarOcorrencia from 'templates/Cadastro/Ocorrencias/modals/Editar'
import ExcluirOcorrencia from 'templates/Cadastro/Ocorrencias/modals/Excluir'
import AdicionarRegrasCalculo from 'templates/Cadastro/RegrasCalculo/atoms/modals/Adicionar'
import EditarRegraCalculoPage from 'templates/Cadastro/RegrasCalculo/atoms/modals/Editar'
import ExcluirRegraCalculoPage from 'templates/Cadastro/RegrasCalculo/atoms/modals/Excluir'
import AdicionarSupervisor from 'templates/Cadastro/Supervisor/atoms/modals/Adicionar'
import AssociarSupervisor from 'templates/Cadastro/Supervisor/atoms/modals/Associar'
import EditarSupervisor from 'templates/Cadastro/Supervisor/atoms/modals/Editar'
import ExcluirSupervisor from 'templates/Cadastro/Supervisor/atoms/modals/Excluir'
import AdicionarTabelaHorarios from 'templates/Cadastro/TabelaHorario/modals/AdicionarPage'
import EditarTabelaHorariosPage from 'templates/Cadastro/TabelaHorario/modals/Editar'
import ExcluirTabelaHorarios from 'templates/Cadastro/TabelaHorario/modals/Excluir'

const OcorrenciasDesativadas = React.lazy(
    () => import('templates/Cadastro/Ocorrencias/Desativadas'),
)
const CentroCusto = React.lazy(() => import('pages/CentroCusto'))
const Empresas = React.lazy(() => import('pages/Empresas'))
const Funcionarios = React.lazy(() => import('pages/Funcionarios'))
const FeriadosCliente = React.lazy(() => import('pages/FeriadosCliente'))
const Locais = React.lazy(() => import('pages/Locais'))
const RegrasCalculo = React.lazy(() => import('pages/RegrasCalculo'))
const Ocorrencias = React.lazy(() => import('pages/Ocorrencias'))
const Supervisor = React.lazy(() => import('pages/Supervisor'))
const TabelaHorario = React.lazy(() => import('pages/TabelaHorario'))
const Rubricas = React.lazy(() => import('pages/Rubricas'))
const Escalas = React.lazy(() => import('pages/Escalas'))
const Permissoes = React.lazy(() => import('pages/Permissoes'))

const base = '/cadastros'
const empresas = '/empresas'
const funcionarios = '/funcionarios'
const funcionarioId = '/funcionarios/:funcionarioId'
const regrasCalculo = '/regras-calculo'
const regrasCalculoId = '/regras-calculo/:regrasCalculoId'

export const cadastros: RouteObject = {
    path: base,
    children: [
        {
            path: base + '/centro-custo',
            element: <CentroCusto />,
            children: [
                {
                    path: base + '/centro-custo/:centroCustoId/funcionarios',
                    element: <FuncionariosCentroCusto />,
                },
                {
                    path: base + '/centro-custo/importar',
                    element: <ImportarCentroCusto />,
                },
                {
                    path: base + '/centro-custo/adicionar',
                    element: <AdicionarCentroCusto />,
                },
                {
                    path: base + '/centro-custo/:id/excluir',
                    element: <ExcluirCentroCusto />,
                },
                {
                    path: base + '/centro-custo/:id/editar',
                    element: <EditarCentroCusto />,
                },
            ],
        },
        {
            path: base + '/feriados',
            element: <FeriadosCliente />,
            children: [
                {
                    path: base + '/feriados/adicionar',
                    element: <AdicionarFeriadoModal />,
                },
                {
                    path: base + '/feriados/:feriadoId/excluir',
                    element: <ExcluirFeriadoModal />,
                },
            ],
        },
        {
            path: base + empresas,
            element: <Empresas />,
            children: [
                {
                    path: base + empresas + '/adicionar',
                    element: <AdicionarEmpresaPage />,
                },
                {
                    path: base + empresas + '/:empresaId/detalhes',
                    element: <DetalhesEmpresaPage />,
                },
                {
                    path: base + empresas + '/:empresaId/editar',
                    element: <EdicaoEmpresaPage />,
                },
            ],
        },
        {
            path: base + funcionarios,
            element: <Funcionarios />,
            children: [
                {
                    path: base + funcionarios + '/adicionar',
                    element: <AdicionarFuncionarioPage />,
                },
                {
                    path: base + funcionarioId + '/detalhes',
                    element: <DetalhesFuncionarioPage />,
                },
                {
                    path: base + funcionarioId + '/detalhes/alterar-senha',
                    element: <AlterarSenhaFuncionario />,
                },
                {
                    path: base + funcionarioId + '/editar',
                    element: <EditarFuncionarioPage />,
                },
                {
                    path: base + funcionarioId + '/editar/alterar-senha',
                    element: <AlterarSenhaFuncionario />,
                },
                {
                    path: base + funcionarios + '/exportar',
                    element: <ExportarFuncionarioPage />,
                },
                {
                    path: base + funcionarios + '/importar',
                    element: <ImportarFuncionarioPage />,
                },
                {
                    path: base + funcionarioId + '/cadastro-facial',
                    element: <CadastroFacialPage />,
                },
            ],
        },
        {
            path: base + '/locais',
            element: <Locais />,
            children: [
                {
                    path: base + '/locais/adicionar',
                    element: <AdicionarLocal />,
                },
                {
                    path: base + '/locais/:id/associar',
                    element: <AssociarLocal />,
                },
                {
                    path: base + '/locais/:id/editar',
                    element: <EditarLocal />,
                },
                {
                    path: base + '/locais/:id/excluir',
                    element: <ExcluirLocal />,
                },
            ],
        },
        {
            path: base + '/ocorrencias-desativadas',
            element: <OcorrenciasDesativadas />,
        },
        {
            path: base + '/ocorrencias',
            element: <Ocorrencias />,
            children: [
                {
                    path: base + '/ocorrencias/adicionar',
                    element: <AdicionarOcorrencias />,
                },
                {
                    path: base + '/ocorrencias/:id/editar',
                    element: <EditarOcorrencia />,
                },
                {
                    path: base + '/ocorrencias/:id/excluir',
                    element: <ExcluirOcorrencia />,
                },
            ],
        },
        {
            path: base + regrasCalculo,
            element: <RegrasCalculo />,
            children: [
                {
                    path: base + regrasCalculo + '/adicionar',
                    element: <AdicionarRegrasCalculo />,
                },
                {
                    path: base + regrasCalculoId + '/editar',
                    element: <EditarRegraCalculoPage />,
                },
                {
                    path: base + regrasCalculoId + '/excluir',
                    element: <ExcluirRegraCalculoPage />,
                },
            ],
        },
        {
            path: base + '/supervisores',
            element: <Supervisor />,
            children: [
                {
                    path: base + '/supervisores/adicionar',
                    element: <AdicionarSupervisor />,
                },
                {
                    path: base + '/supervisores/:id/editar',
                    element: <EditarSupervisor />,
                },
                {
                    path: base + '/supervisores/:id/excluir',
                    element: <ExcluirSupervisor />,
                },
                {
                    path: base + '/supervisores/:id/associar',
                    element: <AssociarSupervisor />,
                },
            ],
        },
        {
            path: base + '/tabela-horarios',
            element: <TabelaHorario />,
            children: [
                {
                    path: base + '/tabela-horarios/:id/editar',
                    element: <EditarTabelaHorariosPage />,
                },
                {
                    path: base + '/tabela-horarios/:id/excluir',
                    element: <ExcluirTabelaHorarios />,
                },
                {
                    path: base + '/tabela-horarios/adicionar',
                    element: <AdicionarTabelaHorarios />,
                },
            ],
        },
        {
            path: base + '/rubricas',
            element: <Rubricas />,
            children: [
                {
                    path: base + '/rubricas/:id/excecoes',
                    element: <ExcecoesRubricas />,
                },
            ],
        },
        {
            path: base + '/escalas',
            element: <Escalas />,
            children: [
                {
                    path: base + '/escalas/adicionar',
                    element: <AdicionarEscalaModal />,
                },
                {
                    path: base + '/escalas/:id/funcionarios',
                    element: <AssociarFuncionarios />,
                    children: [
                        {
                            path:
                                base +
                                '/escalas/:id/funcionarios/:pivot/excluir',
                            element: <ExcluirAssociacao />,
                        },
                    ],
                },
                {
                    path: base + '/escalas/:id/editar',
                    element: <EditarEscalaModal />,
                },
                {
                    path: base + '/escalas/:id/excluir',
                    element: <ExcluirEscala />,
                },
            ],
        },
        {
            path: base + '/permissoes',
            element: <Permissoes />,
            children: [
                {
                    path: base + '/permissoes/adicionar',
                    element: <AdicionarPerfilPermissao />,
                },
                {
                    path: base + '/permissoes/:id/editar',
                    element: <EditarPerfilPermissao />,
                },
                {
                    path: base + '/permissoes/:id/excluir',
                    element: <ExcluirPerfilPermissao />,
                },
                {
                    path: base + '/permissoes/:id/associar',
                    element: <AssociarPerfilPermissao />,
                },
            ],
        },
    ],
}
